/**
 * BookGenerating — skeleton grid loader for pages being generated or loading.
 *
 * Layout from Figma: 3-col × 2-row grid with:
 *   - Top-left (1×1), Top-middle (1×1)
 *   - Right column spans both rows (1×2)
 *   - Bottom-left spans 2 columns (2×1)
 */

import React, { useEffect, useRef } from "react";
import { View, Animated, StyleSheet } from "react-native";

const SKELETON_COLOR = "#CCCCCC";
const GAP = 12;

export default function BookGenerating() {
  const shimmer = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const anim = Animated.loop(
      Animated.sequence([
        Animated.timing(shimmer, { toValue: 0.6, duration: 1000, useNativeDriver: true }),
        Animated.timing(shimmer, { toValue: 0.3, duration: 1000, useNativeDriver: true }),
      ]),
    );
    anim.start();
    return () => anim.stop();
  }, [shimmer]);

  return (
    <View style={s.root}>
      <View style={s.grid}>
        <View style={s.row}>
          <View style={s.leftCols}>
            <View style={s.topRow}>
              <Animated.View style={[s.cell, { opacity: shimmer }]} />
              <Animated.View style={[s.cell, { opacity: shimmer }]} />
            </View>
            <Animated.View style={[s.cellWide, { opacity: shimmer }]} />
          </View>
          <Animated.View style={[s.cellTall, { opacity: shimmer }]} />
        </View>
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  root: { flex: 1, alignItems: "center", justifyContent: "center" },
  grid: {
    height: "100%",
    aspectRatio: 1060 / 596,
    maxWidth: "100%",
    borderWidth: 2,
    borderColor: "rgba(255,255,255,0.4)",
    borderRadius: 12,
    padding: 24,
    opacity: 0.5,
  },
  row: { flex: 1, flexDirection: "row", gap: GAP },
  leftCols: { flex: 2, gap: GAP },
  topRow: { flex: 1, flexDirection: "row", gap: GAP },
  cell: { flex: 1, backgroundColor: SKELETON_COLOR, borderRadius: 8 },
  cellWide: { flex: 1, backgroundColor: SKELETON_COLOR, borderRadius: 8 },
  cellTall: { flex: 1, backgroundColor: SKELETON_COLOR, borderRadius: 8 },
});
